import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type VendorItemAliasFragment = { __typename?: 'VendorItemAlias', aliasId: string, vendorId: string, materialItemId: string, supplierItemId?: string | null, supplierDescription?: string | null, manufacturerKey?: string | null, status: Types.VendorItemAliasStatus, source: Types.VendorItemAliasSource, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, replacedByAliasId?: string | null, version: number, createdAt: Types.TDateISO, retiredAt?: Types.TDateISO | null };

export type VendorItemCandidateFragment = { __typename?: 'VendorItemCandidate', materialItemId: string, materialItemName: string, materialItemErpId?: string | null, vendorItemId?: string | null, rung: Types.ItemMatchRung, score: number, aliasId?: string | null };

export type GetVendorItemAliasesQueryVariables = Types.Exact<{
  vendorId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  materialItemId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeRetired: Types.Scalars['Boolean']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetVendorItemAliasesQuery = { __typename?: 'Query', vendorItemAliases?: { __typename?: 'VendorItemAliasesConnection', totalCount: number, nodes?: Array<{ __typename?: 'VendorItemAlias', aliasId: string, vendorId: string, materialItemId: string, supplierItemId?: string | null, supplierDescription?: string | null, manufacturerKey?: string | null, status: Types.VendorItemAliasStatus, source: Types.VendorItemAliasSource, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, replacedByAliasId?: string | null, version: number, createdAt: Types.TDateISO, retiredAt?: Types.TDateISO | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVendorItemResolutionsQueryVariables = Types.Exact<{
  vendorId: Types.Scalars['String']['input'];
  rows: Array<Types.VendorItemResolveRowInput> | Types.VendorItemResolveRowInput;
  topN: Types.Scalars['Int']['input'];
}>;


export type GetVendorItemResolutionsQuery = { __typename?: 'Query', resolveVendorItems: Array<{ __typename?: 'VendorItemResolution', rowKey: string, outcome: Types.ItemResolveOutcome, skippedAliasIds: Array<string>, match?: { __typename?: 'VendorItemCandidate', materialItemId: string, materialItemName: string, materialItemErpId?: string | null, vendorItemId?: string | null, rung: Types.ItemMatchRung, score: number, aliasId?: string | null } | null, candidates: Array<{ __typename?: 'VendorItemCandidate', materialItemId: string, materialItemName: string, materialItemErpId?: string | null, vendorItemId?: string | null, rung: Types.ItemMatchRung, score: number, aliasId?: string | null }> }> };

export const VendorItemAliasFragmentDoc = new TypedDocumentString(`
    fragment VendorItemAlias on VendorItemAlias {
  aliasId
  vendorId
  materialItemId
  supplierItemId
  supplierDescription
  manufacturerKey
  status
  source
  effectiveFrom
  effectiveUntil
  replacedByAliasId
  version
  createdAt
  retiredAt
}
    `, {"fragmentName":"VendorItemAlias"});
export const VendorItemCandidateFragmentDoc = new TypedDocumentString(`
    fragment VendorItemCandidate on VendorItemCandidate {
  materialItemId
  materialItemName
  materialItemErpId
  vendorItemId
  rung
  score
  aliasId
}
    `, {"fragmentName":"VendorItemCandidate"});
export const GetVendorItemAliasesDocument = new TypedDocumentString(`
    query GetVendorItemAliases($vendorId: String, $materialItemId: String, $includeRetired: Boolean!, $first: Int, $after: String) {
  vendorItemAliases(
    vendorId: $vendorId
    materialItemId: $materialItemId
    includeRetired: $includeRetired
    first: $first
    after: $after
  ) {
    nodes {
      ...VendorItemAlias
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment VendorItemAlias on VendorItemAlias {
  aliasId
  vendorId
  materialItemId
  supplierItemId
  supplierDescription
  manufacturerKey
  status
  source
  effectiveFrom
  effectiveUntil
  replacedByAliasId
  version
  createdAt
  retiredAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVendorItemResolutionsDocument = new TypedDocumentString(`
    query GetVendorItemResolutions($vendorId: String!, $rows: [VendorItemResolveRowInput!]!, $topN: Int!) {
  resolveVendorItems(vendorId: $vendorId, rows: $rows, topN: $topN) {
    rowKey
    outcome
    match {
      ...VendorItemCandidate
    }
    candidates {
      ...VendorItemCandidate
    }
    skippedAliasIds
  }
}
    fragment VendorItemCandidate on VendorItemCandidate {
  materialItemId
  materialItemName
  materialItemErpId
  vendorItemId
  rung
  score
  aliasId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetVendorItemAliases: build.query<GetVendorItemAliasesQuery, GetVendorItemAliasesQueryVariables>({
      query: (variables) => ({ document: GetVendorItemAliasesDocument, variables })
    }),
    GetVendorItemResolutions: build.query<GetVendorItemResolutionsQuery, GetVendorItemResolutionsQueryVariables>({
      query: (variables) => ({ document: GetVendorItemResolutionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetVendorItemAliasesQuery, useLazyGetVendorItemAliasesQuery, useGetVendorItemResolutionsQuery, useLazyGetVendorItemResolutionsQuery } = injectedRtkApi;
